module.exports = __webpack_public_path__ + "static/media/c3po.14a15c61.jpg";